export default __webpack_public_path__ + "static/media/independenciaFinanceira.f6bee252.svg";